<script lang="ts">
  import { onMount } from "svelte";
  import { decode } from "blurhash";

  export let hash: string;
  export let smBlurhash: string;
  export let width = 32;
  export let height = 32;
  export let punch = 1;

  let viewportWidth: number;
  let isMobile = false;
  let mdWidth = 768;
  let canvasEl: HTMLCanvasElement;

  $: isMobile = viewportWidth < mdWidth;

  let blurhash = hash;

  $: (blurhash = isMobile ? (smBlurhash ? smBlurhash : hash) : hash), isMobile;

  onMount(() => {
    const pixels = decode(hash, width, height, punch);
    const ctx = canvasEl.getContext("2d");
    const imageData = ctx.createImageData(width, height);
    imageData.data.set(pixels);
    ctx.putImageData(imageData, 0, 0);
  });
</script>

<style lang="scss">
  .blurhash-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.5s ease-in-out;
  }
</style>

<svelte:window bind:innerWidth={viewportWidth} />

<canvas bind:this={canvasEl} {width} {height} class="blurhash-placeholder" />
